export default __webpack_public_path__ + "static/media/stake-hover.d2660ba4.svg";